import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import { Button, List, ListItem } from 'twyne-new.ui';

export default function DeleteConfirmationContent({ origin, loadReferences, action }) {
  const [references, setReferences] = useState(null)

  useEffect(() => {
    loadReferences().then(references => {
      setReferences(references)
    })
  }, [])

  if (!references)
    return "Loading"

  if (!Object.keys(references).length) {
    return <Group>
      <Button
        color='danger'
        className='mt-2 w-full flex justify-center'
        onClick={action}
      >
        Yes, I am sure
      </Button>
    </Group>
  }

  return <Group>
    <ConfirmationContent origin={origin} references={references} action={action}/>
  </Group>
}
DeleteConfirmationContent.propTypes = {
  origin: PropTypes.string,
  loadReferences: PropTypes.func,
  action: PropTypes.func
}

function ConfirmationContent ({ origin, references, action }) {
  if (origin === 'offer')
    return <OfferContent references={references} action={action}/>

  if (origin === 'publisher')
    return <PublisherContent references={references} action={action}/>

  if (origin === 'form')
    return <FormContent references={references} action={action}/>

  if (origin === 'post')
    return <PostContent references={references} action={action}/>

  return null
}
ConfirmationContent.propTypes = {
  origin: PropTypes.string,
  references: PropTypes.object,
  action: PropTypes.func
}

function OfferContent({ references }) {
  const { allocations } = references
  const allocationIsDefault = allocations.some(a => a.default)

  return <>
    {allocationIsDefault ?
      <h6>This entry has reference the default <strong>allocation</strong> from the current site. Change the reference or disable the default flag to that allocation before deleting it:</h6> : 
      <h6>This entry has reference to <strong>allocation</strong> from the currenct site. Change the reference to that allocation before deleting it:</h6> }
    <ReferencesList references={allocations} />
  </>
}
OfferContent.propTypes = {
  references: PropTypes.object,
  action: PropTypes.func,
}

function PublisherContent ({ references }) {
  const { allocations } = references
  const allocationIsDefault = allocations && allocations.some(a => a.default)

  return <>
    { allocationIsDefault ?
      <h6>This entry has reference the default <strong>allocation</strong> from the current site. Change the reference or disable the default flag to that allocation before deleting it:</h6> :
      <h6>This entry has references to <strong>allocations</strong> from the current organization. Remove these references before deleting it:</h6> }
    <ReferencesList references={allocations} />
  </>
}
PublisherContent.propTypes = {
  references: PropTypes.object,
}

function FormContent({ references }) {
  const key = references.allocations ? 'allocations' : 'posts'
  const referencesData = references[key]
  const allocationIsDefault = references.allocations && references.allocations.some(a => a.default)

  return <>
    {key === 'allocations' ? <>
      {allocationIsDefault ? <h6>This entry has reference the default <strong>allocation</strong> from the current site. Change the reference or disable the default flag to that allocation before deleting it:</h6> : <h6>This entry has references to <strong>allocations</strong> from the current organization. Remove these references before deleting it:</h6>}
    </> : <>
      <h6>This entry has references to <strong>posts</strong> from the current organization. Remove these references before deleting it:</h6>
    </>}
    <ReferencesList references={referencesData} />
  </>
}
FormContent.propTypes = {
  references: PropTypes.object,
}

function PostContent({ references }) {
  const { offers } = references

  return <>
    <h6>This entry has references to <strong>offers</strong> from the current organization. Remove these references before deleting it:</h6>
    <ReferencesList references={offers} />
  </>
}
PostContent.propTypes = {
  references: PropTypes.object,
}

function Group({ children }) {
  return <div>
    <div className='mb-2 font-bold'>Are you sure you want to delete this entry?</div>
    {children}
  </div>
}

function ReferencesList({ references }) {
  return <List className='px-0! max-h-[50vh] overflow-y-auto'>
    {references && references.map(({ id, description, url, default: _default, site_id }) => <>
      <ListItem
        value={<>[#{id}] {description} {site_id ? ` - site ${site_id}` : ''}</>}
        key={`id-${id}`}
        onClick={() => window.location.href = url}
        badge={_default ? `default` : ''}
      />
    </>)}
  </List>
}
